// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"218":"b9703451","855":"b9703451"}[chunkId] + ".chunk.css";
};